import React from 'react';
import {Autocomplete, Chip, Paper, TextField, ToggleButton, ToggleButtonGroup, Typography, Button, CircularProgress} from "@mui/material";
import Grid from "@mui/material/Grid2";

function GraffitiInterventionsFilters({
    // période via presets + dates
    preset,
    onPresetChange,
    dateDebut,
    dateFin,
    onDateDebutChange,
    onDateFinChange,
    // options
    communes = [],
    quartiers = [],
    ruesOptions = [],
    ruesLoading = false,
    // values
    selectedCommunes = [],
    selectedQuartiers = [],
    selectedRues = [],
    // callbacks
    onCommunesChange,
    onQuartiersChange,
    onRuesChange,
    onRuesInputChange,
    // export
    onExportClick,
    exportLoading = false,
}) {

    const getOptionId = (opt) => {
        if (!opt) return null;
        return (typeof opt.id !== 'undefined') ? opt.id : (typeof opt.value !== 'undefined' ? opt.value : null);
    };
    const getOptionLabel = (opt) => {
        if (!opt) return '';
        return opt.libelle || opt.label || opt.nom || String(opt.id ?? opt.value ?? '');
    };

    return (
        <Grid container spacing={1}>
            <Grid size={{ xs: 12 }}>
                <Paper elevation={1} style={{ padding: 8, marginBottom: 8 }}>
                    <Grid container spacing={2} alignItems="center" justifyContent="space-between">
                        <Grid>
                            <Typography variant="subtitle1">Période</Typography>
                        </Grid>
                        <Grid>
                            <ToggleButtonGroup
                                color="primary"
                                exclusive
                                value={preset}
                                onChange={(e, val) => val && onPresetChange && onPresetChange(val)}
                                size="small"
                            >
                                <ToggleButton value="last_month">Mois dernier</ToggleButton>
                                <ToggleButton value="last_week">Semaine dernière</ToggleButton>
                                <ToggleButton value="this_week">Cette semaine</ToggleButton>
                                <ToggleButton value="this_month">Ce mois-ci</ToggleButton>
                            </ToggleButtonGroup>
                        </Grid>
                        <Grid>
                            <TextField
                                label="Date début"
                                type="date"
                                size="small"
                                value={dateDebut || ''}
                                onChange={(e) => onDateDebutChange && onDateDebutChange(e.target.value)}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid>
                            <TextField
                                label="Date fin"
                                type="date"
                                size="small"
                                value={dateFin || ''}
                                onChange={(e) => onDateFinChange && onDateFinChange(e.target.value)}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid sx={{ marginLeft: 'auto' }}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => onExportClick && onExportClick()}
                                disabled={exportLoading || !dateDebut || !dateFin}
                                size="small"
                            >
                                {exportLoading && <CircularProgress size={16} color="inherit" style={{ marginRight: 8 }} />}
                                Exporter Excel
                            </Button>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>

            <Grid size={{ xs: 12 }}>
                <Paper elevation={1} style={{ padding: 8, marginBottom: 8 }}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Autocomplete
                                multiple
                                options={communes || []}
                                value={selectedCommunes}
                                onChange={(e, value) => onCommunesChange && onCommunesChange(value)}
                                isOptionEqualToValue={(opt, val) => getOptionId(opt) === getOptionId(val)}
                                getOptionLabel={(opt) => getOptionLabel(opt)}
                                renderTags={(value, getTagProps) => value.map((option, index) => (
                                    <Chip {...getTagProps({ index })} key={`commune-chip-${getOptionId(option)}`} label={getOptionLabel(option)} variant="outlined" />
                                ))}
                                renderInput={(params) => <TextField {...params} label="Communes" placeholder="Sélectionner des communes" size="small" />}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Autocomplete
                                multiple
                                options={quartiers || []}
                                value={selectedQuartiers}
                                onChange={(e, value) => onQuartiersChange && onQuartiersChange(value)}
                                isOptionEqualToValue={(opt, val) => getOptionId(opt) === getOptionId(val)}
                                getOptionLabel={(opt) => getOptionLabel(opt)}
                                renderTags={(value, getTagProps) => value.map((option, index) => (
                                    <Chip {...getTagProps({ index })} key={`quartier-chip-${getOptionId(option)}`} label={getOptionLabel(option)} variant="outlined" />
                                ))}
                                renderInput={(params) => <TextField {...params} label="Quartiers" placeholder="Sélectionner des quartiers" size="small" />}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Autocomplete
                                multiple
                                filterOptions={(x) => x}
                                options={ruesOptions || []}
                                loading={!!ruesLoading}
                                value={selectedRues}
                                onChange={(e, value) => onRuesChange && onRuesChange(value)}
                                onInputChange={(e, value) => onRuesInputChange && onRuesInputChange(value)}
                                isOptionEqualToValue={(opt, val) => getOptionId(opt) === getOptionId(val)}
                                getOptionLabel={(opt) => getOptionLabel(opt)}
                                renderTags={(value, getTagProps) => value.map((option, index) => (
                                    <Chip {...getTagProps({ index })} key={`rue-chip-${getOptionId(option)}`} label={getOptionLabel(option)} variant="outlined" />
                                ))}
                                renderInput={(params) => <TextField {...params} label="Rues" placeholder="Rechercher des rues" size="small" />}
                            />
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        </Grid>
    );
}

export default GraffitiInterventionsFilters;
